import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export const BakolaPayFeaturesCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('supportedFeatures')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('paymentProcessing')}</h4>
                        <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
                            <li>{t('bakolaPaySecurePayments')}</li>
                            <li>{t('bakolaPayFraudDetection')}</li>
                            <li>{t('bakolaPayRealtimeMonitoring')}</li>
                            <li>{t('bakolaPayRefunds')}</li>
                            <li>{t('bakolaPayWebhooks')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('processorType')}</h4>
                        <div className="flex flex-wrap gap-2">
                            <Badge variant="outline">{t('bakolaPayPaymentProcessing')}</Badge>
                            <Badge variant="outline">{t('bakolaPayRefunds')}</Badge>
                            <Badge variant="outline">{t('bakolaPayWebhooks')}</Badge>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
